export enum AuditActionType {
  Delete = 1,
  Insert = 2,
  Update = 3
}
